//import * as interfaces from './sharedInterfaces';
import * as interfaces from "../Shared/sharedInterfaces";
import * as dbFunctions from "./modules";
import * as userDbFunctions from "./userInfo";
import { GetOutputsFromDatabase } from "./items";
import { getWebCatsFromDatabase } from "./webcats";
import { GetUserSettings } from "../database/userInfo";
import { useSettings } from "../Navbar/settingsContext";

interface OutputModules {
  id: number;
  nodeid: string;
  label: string;
  type: string;
  parent: string;
  typeIcon: string;
  moduleType: string;
  webCat: number;
}

async function getWebCats() {
  const retrievedWebCats = await getWebCatsFromDatabase().then(
    (webCats: any) => {
      const dbWebCats = webCats.success;
      let retWebCats: interfaces.WebsiteCategories[] = [];
      dbWebCats.forEach((webcat: any) => {
        const webcats: interfaces.WebsiteCategories = {
          id: webcat.id,
          volgorde: webcat.volgorde,
          io_type: webcat.io_type,
          typeIcon: webcat.typeIcon,
          categorie_nl: webcat.categorie_nl,
          categorie_fr: webcat.categorie_fr,
          categorie_en: webcat.categorie_en,
        };
        retWebCats.push(webcats);
      });
      return retWebCats;
    }
  );
  sessionStorage.setItem("webcats", JSON.stringify(retrievedWebCats));
  return retrievedWebCats;
}

// opbouw - modules - modulesfunctions
export async function getModules() {
  const retrievedModules = await dbFunctions
    .getModulesFromDatabase()
    .then((modules: any) => {
      //console.log("getModules2",modules.success)
      const dbMods = modules.success;

      let retModules: interfaces.ModuleTypes[] = [];

      dbMods.forEach((mod: any) => {
        const mods: interfaces.ModuleTypes = {
          id: mod.id,
          obsolete: mod.obsolete,
          type: mod.type,
          name: mod.name,
          outputs: mod.outputs,
          nextModule: mod.nextModule,
          parentModule: mod.parentModule,
          pakket: mod.pakket,
          inputs: mod.inputs,
          busConsumption: mod.busConsumption,
          adresses: mod.adresses,
          sa: mod.sa,
          din: mod.din,
          icon: mod.icon,
          prijs: mod.prijs,
          offCat: mod.offCat,
          webCat: mod.webCat,
        };
        retModules.push(mods);
      });

      sessionStorage.setItem("DbModules", JSON.stringify(retModules));
      return retModules;
    });

  await dbFunctions.getExtendedModuleFromDatabase().then((modules: any) => {
    //console.log("getModules2",modules.success)
    const dbMods = modules.success;

    let retModulesExtended: interfaces.ExtendedModuleTypes[] = [];

    dbMods.forEach((mod: any) => {
      const mods: interfaces.ExtendedModuleTypes = {
        id: mod.id,
        module_id: mod.module_id,
        beschrijving: mod.beschrijving,
        korteBeschrijving: mod.korteBeschrijving,
        url: mod.url,
        //prijs: mod.prijs,
        //offCat: mod.offCat,
      };
      retModulesExtended.push(mods);
    });

    sessionStorage.setItem(
      "DbExtendedModuleTypes",
      JSON.stringify(retModulesExtended)
    );
    return retModulesExtended;
  });

  return retrievedModules;
}

async function getInputs() {
  const inp = await GetOutputsFromDatabase("ingangen").then(
    (outputmodulesDB: any) => {
      const dbMods = outputmodulesDB.success;

      const obsoleteTypes = new Set(
        (JSON.parse(sessionStorage.getItem("DbModules") || "[]") as interfaces.ModuleTypes[])
          .filter((m) => m.obsolete === 1)
          .map((m) => m.type)
      );

      let outputs: OutputModules[] = [];

      dbMods.forEach((mod: any) => {
        if (mod.moduleType && obsoleteTypes.has(mod.moduleType)) return;
        const mods: OutputModules = {
          id: mod.id,
          nodeid: mod.nodeid,
          label: mod.label,
          type: mod.type,
          parent: mod.parent,
          typeIcon: mod.typeIcon,
          moduleType: mod.moduleType,
          webCat: mod.webCat,
        };
        outputs.push(mods);
      });
      sessionStorage.setItem("modulesInputs", JSON.stringify(outputs));
      return outputs;
    }
  );
  return inp;
}

interface customer {
  id: number;
  user_id: number;
  naam: string;
  voornaam: string;
}
/*
interface customers {
  success: [
    {
      id: number;
      user_id: number;
      naam: string;
      voornaam: string;
      firma: string;
      straat: string;
      huisnr: string;
      postcode: string;
      gemeente: string;
      land: string;
      telefoon: string;
      btwnr: string;
    }
  ];
}
*/
// Load items for uitgangen / ingangen menu tree
async function getOutputs() {
  const outp = await GetOutputsFromDatabase("uitgangen").then(
    (outputmodulesDB: any) => {
      const dbMods = outputmodulesDB.success;

      const obsoleteTypes = new Set(
        (JSON.parse(sessionStorage.getItem("DbModules") || "[]") as interfaces.ModuleTypes[])
          .filter((m) => m.obsolete === 1)
          .map((m) => m.type)
      );

      let outputs: OutputModules[] = [];

      dbMods.forEach((mod: any) => {
        if (mod.moduleType && obsoleteTypes.has(mod.moduleType)) return;
        const mods: OutputModules = {
          id: mod.id,
          nodeid: mod.nodeid,
          label: mod.label,
          type: mod.type,
          parent: mod.parent,
          typeIcon: mod.typeIcon,
          moduleType: mod.moduleType,
          webCat: mod.webCat,
        };
        outputs.push(mods);
      });
      sessionStorage.setItem("modulesOutputs", JSON.stringify(outputs));
      return outputs;
    }
  );

  return outp;
}

async function getCustommers() {
  const custommers = await userDbFunctions
    .GetCustomers()
    .then((custommers: any) => {
      const clients = custommers.success;

      let retCustommers: any[] = [];

      clients.forEach((client: any) => {
        const clients: customer = {
          id: client.id,
          user_id: client.user_id,
          naam: client.naam,
          voornaam: client.voornaam,
        };
        retCustommers.push(clients);
      });
      return retCustommers;
    });
  sessionStorage.setItem("DbCustommers", JSON.stringify(custommers));
  return custommers;
}

export async function loadDatabases() {
  
  await getModules();
  await getOutputs();
  await getInputs();
  await getCustommers();
  await getWebCats();

  //await GetUserSettings();
  //setUserSettings(data.success)
  //console.log(o)
  //resolve (true)
  //  });
  return true;
}
